var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"annotation-list"},_vm._l((_vm.annotations),function(annotation){return _c('annotation-edit',{key:annotation.getId(),attrs:{"annotation":annotation}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }